<template>
  <div>
    <ui-dialog :show="isOpen" max-width="542" @input="handleClose">
      <template #header>
        <h3>
          {{ $t("message.notes.note") }}
        </h3>
      </template>
      <v-textarea
        v-model="noteText"
        ref="input"
        :label="$t('message.notes.note')"
        autofocus
        no-resize
        hide-details
        rows="3"
      ></v-textarea>
      <template #actions>
        <div
          :class="{ 'justify-end': !note, 'justify-space-between': note }"
          class="w-100 d-flex "
        >
          <ui-button
            v-if="note"
            icon="icon-trash"
            outlined
            color="pink"
            icon-color="red"
            @click="showDeleteDialog = true"
          >
            {{ $t("message.notes.deleteNote") }}
          </ui-button>
          <ui-button
            :disabled="!noteText"
            color="primary"
            @click="note ? handleUpdate() : handleSave()"
          >
            {{ $t("message.common.save") }}
          </ui-button>
        </div>
      </template>
    </ui-dialog>
    <DeleteNoteDialog
      v-if="showDeleteDialog"
      :is-open="showDeleteDialog"
      @delete="handleDelete"
      @close="showDeleteDialog = false"
    />
  </div>
</template>

<script>
import reviewsService from "@/services/reviews";
import ErrorHandler from "@/helpers/handlers/error";
import { GTM_EVENT_NAME } from "@/enums/gtm-events";

export default {
  name: "ModifyNoteDialog",
  components: {
    DeleteNoteDialog: () => import("@/components/Reviews/DeleteNoteDialog.vue")
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    note: {
      type: String
    },
    reviewId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      noteText: null,
      showDeleteDialog: false
    };
  },

  created() {
    this.noteText = this.note;
  },

  methods: {
    handleClose() {
      this.$emit("close");
    },
    async handleSave() {
      this.modifyNote(async () => {
        await reviewsService.postNote(this.reviewId, this.noteText);
        this.$notify({
          group: "default",
          type: "success",
          text: this.$t("message.notes.noteAdded")
        });
        this.$gtm.trackCustomEvent({
          event: GTM_EVENT_NAME.REVIEW_LIST_NOTE_ACTION,
          action: "add"
        });
      });
    },
    async handleUpdate() {
      this.modifyNote(async () => {
        await reviewsService.patchNote(this.reviewId, this.noteText);
        this.$notify({
          group: "default",
          type: "success",
          text: this.$t("message.notes.noteUpdated")
        });

        this.$gtm.trackCustomEvent({
          event: GTM_EVENT_NAME.REVIEW_LIST_NOTE_ACTION,
          action: "edit"
        });
      });
    },
    async handleDelete() {
      this.modifyNote(async () => {
        await reviewsService.deleteNote(this.reviewId);
        this.noteText = null;
        this.$notify({
          group: "default",
          type: "success",
          text: this.$t("message.notes.noteDeleted")
        });
        this.$gtm.trackCustomEvent({
          event: GTM_EVENT_NAME.REVIEW_LIST_NOTE_ACTION,
          action: "remove"
        });
      });
    },
    async modifyNote(callback) {
      try {
        await callback();
        this.$emit("change", this.noteText);
      } catch (error) {
        ErrorHandler.displayError(error);
      }
    }
  }
};
</script>
